export const SKIP_QUIZ_QUESTION = `SKIP_QUIZ_QUESTION`;

export const skipQuizQuestion = () => ({
  type: SKIP_QUIZ_QUESTION,
});
